var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',_vm._b({on:{"click":_vm.logout}},'v-list-item',_vm.$attrs,false),[_c('v-list-item-title',[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-logout")]),_vm._v("Logout\n  ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }